import { gql } from '@apollo/client';

export default gql`
  query partnerContactCategory($id: ID!) {
    partnerContactCategory(id: $id) {
      id
      name
      description
      createdAt
      updatedAt
    }
  }
`;
